import { NextRouter, useRouter } from 'next/router';

import { TabItem, TabList } from '@reckon-web/tabs';
import { Link } from '@reckon-web/link';
import { Box } from '@reckon-web/box';

const tabs = [{ name: 'Users', path: '/', match: ['/'] }];

type RouteType = (typeof tabs)[number];

export const Navigation = () => {
  const router = useRouter();

  const tabMap = (router: NextRouter) => (route: RouteType) => {
    const isSelected = route.match.includes(router.pathname);

    return (
      <TabItem
        id={`Header-TabItem-${route.name}`}
        as={Link}
        href={route.path}
        isSelected={isSelected}
        key={route.path}
      >
        {route.name}
      </TabItem>
    );
  };

  return (
    <Box paddingX="large">
      <TabList color="green">{tabs.map(tabMap(router))}</TabList>
    </Box>
  );
};
